import React from 'react';

import { Link, MenuItem as MuiMenuItem, MenuItemProps } from '@ha/dsl';

interface Props {
  rel?: string;
  to?: string;
  children: React.ReactNode;
}

export default React.forwardRef<HTMLLIElement, Props & MenuItemProps>(
  ({ to, ...rest }, ref) => {
    const componentProps = to
      ? { to, component: Link, kind: 'dark-blue', disableOutline: true }
      : undefined;

    return <MuiMenuItem ref={ref} {...rest} button {...componentProps} />;
  },
);
